let config;
if (
  process.env.NODE_ENV == "production" &&
  location.href.indexOf(".lan") === -1 &&
  location.href.indexOf("192.168") === -1 &&
  location.href.indexOf("localhost") === -1
) {
  //正式机
  config = {
    API_BASE_URL: "/apis/", //API接口地址配置    /apis/
    API_BASE_ANT: "https://www.jf24k.hk/url/", //快捷支付短连接获取接口地址
    IMG_URL: "http://media.jf24k.hk/", //图片服务器地址配置
    ACCOUNT_URL: "https://account.jf24k.hk/", //开户站点链接配置
    ANT_URL: "https://hs2ant.wordkei.com/", //快捷支付PC版连接配置
    ServerIP: "[HKLive]47.52.210.28",
    logUrl: "https://nxcollect.hflbysm.com/bin-log",
    BASE_LOGIN_URL: "https://www.jf24k.hk/login/index.html",
    FRIEND_LINK: "https://www.jfgolds.com/account/real/firendopen.html",
    BASE_LIVE800_URL: "https://www.jf24k.hk/common/live800.html",
    BASE_IMG_URL_ANTSWALLETS: "https://uapi.antswallets.com/", //蚂蚁钱包图片服务器地址
    BASE_IMG_URL_GOLDJUMP: "https://hs2ant.wordkei.com/"
  };
} else {
  config = {
    API_BASE_URL: "/apis/", //API接口地址配置    /apis/
    API_BASE_ANT: "http://url.lan/", //快捷支付短连接获取接口地址
    IMG_URL: "http://192.168.0.12", //图片服务器地址配置
    ACCOUNT_URL: "http://account.jf24k.lan", //开户站点链接配置
    ANT_URL: "http://apm.magiccompass.cn:18078/", //蚂蚁钱包PC版连接配置
    NEW_APIS: "http://api.cms.lan/", //蚂蚁钱包PC版连接配置
    ServerIP: "[西安测试]",
    logUrl: "https://nxcollect.hflbysm.com/bin-log",
    BASE_LOGIN_URL: "http://www.jf24k.lan/login/index.html",
    FRIEND_LINK: "https://www.jfgolds.com/account/real/firendopen.html",
    BASE_LIVE800_URL: "https://www.jf24k.hk/common/live800.html",
    BASE_IMG_URL_ANTSWALLETS: "http://192.168.0.247:8817/", //蚂蚁钱包图片服务器地址
    BASE_IMG_URL_GOLDJUMP: "http://upay.antswallets.lan/"
  };
}
export default config;



// WEBPACK FOOTER //
// ./src/axios/config.js